












import mixins from 'vue-typed-mixins';
import { genVuexComputeds } from '@/main/pages/listFactory';
import { mapActionsDvm, mapMutationsDvm } from '@/main/pages';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { OperationsMixin } from '@/main/mixins/operations';
import { makeInjector } from '@/main/utils/vue';
import { PageMode } from '@/main/utils/pageMode';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { apiProvider } from '../api';
import { store } from '../store/list';
import { RozsahDate } from '../constants';
import Varia from '../../components/Varia.vue';

const propInjector = makeInjector<{ storeUri: string }>();

export default propInjector(mixins(PageModeMixin, OperationsMixin), ['storeUri']).extend({
	name: 'BaseFilterSestav',
	inject: ['storeUri'],
	props: {
		titleKey: { type: String },
		disabledDetailTisk: { type: Boolean, default: false },
	},
	components: {
		DmsPdfDialog,
		Varia,
	},
	data() {
		return {
			showTiskDialog: false,
		};
	},
	computed: {
		...genVuexComputeds(store),
		storeName(): string {
			return this.storeUri.split('/')[1];
		},
		pageMode(): PageMode {
			return PageMode.CREATE;
		},
		RozsahDate: {
			get(): RozsahDate {
				return this.$store.state.pages[this.storeName].filter.RozsahDate;
			},
			set(val: RozsahDate) {
				this.setRozsahDate(val);
			},
		},
		isDatesDisable(): boolean {
			return this.RozsahDate !== RozsahDate.casLibObdobi;
		},
		canGenerateReport(): boolean {
			return !this.dmsSys.EnableTaiwanPrp;
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		...mapMutationsDvm(store.mutations),
		generatePdf() {
			this.showTiskDialog = true;
		},
		async fetchPdfProvider() {
			return apiProvider.getReport(this.$route.name!, this.filter);
		},
	},
});
